<template>
  <div :class="['card', classes.card]">
    <div class="card-header-icon">
      <h2 class="h4 mb-0">{{ title }}</h2>
      <i class="bx bx-news" aria-hidden="true" />
    </div>
    <div v-if="items.length" class="card-body p-0">
      <ul :class="['list-group list-group-flush overflow-y-auto', classes.listGroup]">
        <a
          v-for="(item, index) in items"
          :key="index"
          :href="item.url"
          :class="['list-group-item list-group-item-action whats-new-item', `list-group-item-${item.variant}`]"
        >
          <i :class="`bx bx-${item.icon || 'info-square'}`" aria-hidden="true" />
          <time :datetime="item.date" class="text-body-tertiary fs-12">{{ item.date && formatDate(item.date, 'MMM DD, YYYY') }}</time>
          <span>{{ item.label }}</span>
        </a>
      </ul>
    </div>
    <div v-else class="card-body text-body-tertiary fst-italic">{{ noItemsText }}</div>
  </div>
</template>

<script setup>
import { toRefs } from 'vue'
import { formatDate } from '@shared/utils/date'

const props = defineProps({
  items: {
    type: Array,
    default: () => ([]),
  },
  noItemsText: {
    type: String,
    default: 'No recent news.',
  },
  title: {
    type: String,
    default: 'What\'s New',
  },
  classes: {
    type: Object,
    default: () => ({}),
  },
})

const { classes, items, noItemsText, title } = toRefs(props)
</script>

<style>
.whats-new-item {
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-rows: auto auto;
  column-gap: .75rem;

  .bx {
    grid-row: 1 / -1;
    margin-top: .25rem;
    font-size: 2rem;
  }
}
</style>
